import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock } from "react-icons/fa";
import api from "./api/api";

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await api.loginUser(username, password);
      if (data?.CheckLoginjs?.Table?.[0]?.Result === "login successfully") {
        //localStorage.setItem("user", JSON.stringify(data.CheckLoginjs.Table[0]));
        sessionStorage.setItem("user", JSON.stringify(data.CheckLoginjs.Table[0]));
        navigate("/Menu");
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 px-3">
      <div className="bg-white w-full max-w-sm rounded-xl shadow-lg p-6">
        <div className="flex flex-col items-center mb-6">
          <h2 className="text-xl font-bold text-gray-800">Sppipe-Jctrack</h2>
          <h2 className="text-xl font-bold text-gray-800">Login</h2>
        </div>

        {error && (
          <p className="text-red-500 text-sm mb-3 text-center">{error}</p>
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="relative">
            <FaUser className="absolute top-3 left-3 text-gray-400" />
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              className={`w-full pl-10 pr-3 py-2 border rounded-md text-sm transition focus:outline-none focus:ring-2 focus:ring-blue-400 ${username ? "bg-blue-50" : "bg-gray-50"
                } hover:bg-blue-100`}
              required
            />
          </div>

          <div className="relative">
            <FaLock className="absolute top-3 left-3 text-gray-400" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className={`w-full pl-10 pr-3 py-2 border rounded-md text-sm transition focus:outline-none focus:ring-2 focus:ring-blue-400 ${password ? "bg-blue-50" : "bg-gray-50"
                } hover:bg-blue-100`}
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 rounded-md text-sm font-semibold text-white transition ${loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700 active:bg-blue-800"
              }`}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
